import { useGetDashboardTypeDisplayNameFromURLParam } from '@modules/common/hooks';
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  StackProps,
} from '@mui/material';

interface ChooseFeedPreviewTypeFormProps {
  shouldShowAsFeed: boolean;
  containrSx?: StackProps['sx'];
  setShouldShowAsFeed: (shouldShowAsFeed: boolean) => void;
}

export function ChooseFeedPreviewTypeForm({
  setShouldShowAsFeed,
  shouldShowAsFeed,
  containrSx,
}: ChooseFeedPreviewTypeFormProps) {
  const dashboardTypeDisplayName = useGetDashboardTypeDisplayNameFromURLParam();

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      sx={{ ...containrSx }}
    >
      <FormControl>
        <FormLabel sx={{ mb: 2 }}>
          How do you want to see this Feed on the {dashboardTypeDisplayName}?
        </FormLabel>
        <RadioGroup
          value={shouldShowAsFeed ? 'list' : 'prompt'}
          onChange={(eve) => {
            setShouldShowAsFeed(eve.target.value === 'list');
          }}
        >
          <FormControlLabel
            value="prompt"
            control={<Radio />}
            label="Answer to Prompt"
          />
          <FormControlLabel
            value="list"
            control={<Radio />}
            label="List of Feedback Records"
          />
        </RadioGroup>
      </FormControl>
      <Alert severity="info">
        You can always update the Feed view later from the{' '}
        {dashboardTypeDisplayName}.
      </Alert>
    </Stack>
  );
}
